<template>
  <div id="app">
    <HomeCom />
  </div>
</template>

<script>
import HomeCom from "./components/home.vue";

export default {
  name: "App",
  components: {
    HomeCom,
  },
};
</script>

<style>
#app {
  font-family: PingFangSC, PingFang SC;
  display: flex;
  justify-content: center;
  align-items: center;
}
body {
  margin: 0;
  padding: 0;
}
</style>
